import { Link } from 'react-router-dom';

const reportPagePath = '/dashboard/2/reports/';

const reportsList = [
  {
    title: 'Отчет по заводу',
    description: 'Посмотреть отчет по заводу',
    path: `${reportPagePath}1`,
  },
  {
    title: 'Отчет по выполненным действиям',
    description: 'Посмотреть отчет по выполненным действиям',
    path: `${reportPagePath}2`,
  },
  {
    title: 'Отчет по закрытию периода самооценки',
    description: 'Посмотреть отчет по закрытию периода самооценки',
    path: `${reportPagePath}3`,
  },
  // {
  //   title: 'Отчет по KPI',
  //   description: 'Посмотреть отчет по KPI',
  //   path: `${reportPagePath}4`,
  // },
];

type ReportsListProps = {
  onSetCrumbs: (crumbs: string) => void;
};

function ReportsList({ onSetCrumbs }: ReportsListProps) {
  return (
    <div>
      <div className='grid grid-cols-2 py-5 px-7.5 gap-5'>
        {reportsList.map((report) => (
          <div key={report.path}>
            <Link
              to={report.path}
              onClick={() => {
                onSetCrumbs(report.title);
              }}
              title={report.description}
              className='bg-white shadow-custom py-[60px] flex rounded-md justify-center gap-2 font-medium hover:text-darkblue'
            >
              {report.title}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReportsList;
